var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.933 16.933",
    id: "MpFile",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.968,
    transform: "matrix(1.03366 0 0 1.03333 -2.911 3.935)",
    fill: "#437ef7",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.9217235,-3.8085938 A 0.25603411,0.25603411 0 0 0 4.6658641,-3.5527344 V 12.322266 a 0.25603411,0.25603411 0 0 0 0.2558594,0.255859 H 17.093598 a 0.25603411,0.25603411 0 0 0 0.255859,-0.255859 V 1.3886719 a 0.25603411,0.25603411 0 0 0 -0.07227,-0.1796875 l -4.796875,-4.9179688 v -0.00195 a 0.25600851,0.25600851 0 0 0 -0.01953,-0.019531 0.25600851,0.25600851 0 0 0 -0.02149,-0.019531 0.25600851,0.25600851 0 0 0 -0.02344,-0.017578 0.25600851,0.25600851 0 0 0 -0.02344,-0.013672 0.25600851,0.25600851 0 0 0 -0.01367,-0.00586 0.25600851,0.25600851 0 0 0 -0.02539,-0.00977 0.25600851,0.25600851 0 0 0 -0.01367,-0.00391 0.25600851,0.25600851 0 0 0 -0.0059,0 0.25600851,0.25600851 0 0 0 -0.03711,-0.00586 0.25600851,0.25600851 0 0 0 -0.01367,-0.00195 0.25600851,0.25600851 0 0 0 -0.0059,0 h -0.0078 z m 0.2558594,0.5117188 h 6.9902341 l 4.669922,4.7890625 V 12.066406 H 5.1775829 Z",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    opacity: 0.99,
    overflow: "visible",
    fill: "#437ef7",
    className: "color000000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.269531 -3.8085938 A 0.25603411 0.25603411 0 0 0 12.021484 -3.5527344 L 12.021484 1.3886719 A 0.25603411 0.25603411 0 0 0 12.277344 1.6445312 L 17.09375 1.6445312 A 0.25603411 0.25603411 0 0 0 17.277344 1.2089844 L 12.460938 -3.7304688 A 0.25603411 0.25603411 0 0 0 12.269531 -3.8085938 z M 12.533203 -2.921875 L 16.488281 1.1328125 L 12.533203 1.1328125 L 12.533203 -2.921875 z ",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    opacity: 0.99,
    overflow: "visible",
    fill: "#437ef7",
    className: "color000000 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      lineHeight: 2,
      InkscapeFontSpecification: "Calibri",
      textAlign: "center"
    },
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.265,
    "aria-label": "MP4",
    fontFamily: "Calibri",
    fontSize: 5.292,
    opacity: 0.99,
    textAnchor: "middle",
    className: "colorStroke000000 svgStroke"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#437ef7",
    stroke: "none",
    d: "M7.4266775 15.09727q0 .02067-.010335.03617-.010335.0155-.036174.02584-.025838.0078-.067179.01292-.038757.0078-.103353.0078-.059428 0-.1033529-.0078-.041341-.0052-.067179-.01292-.023254-.01033-.03359-.02584-.010335-.0155-.010335-.03617v-2.911968h-.00517l-1.1911425 2.924887q-.00775.01809-.023254.03101-.012919.01292-.041341.02326-.025838.0078-.064596.01033-.036174.0052-.08785.0052-.05426 0-.093018-.0052-.038757-.0052-.064596-.01292-.025838-.01033-.041341-.02326-.012919-.01292-.018087-.02842l-1.139466-2.924887h-.00258v2.911968q0 .02067-.010335.03617-.010335.0155-.036174.02584-.025838.0078-.067179.01292-.041341.0078-.1059367.0078-.062012 0-.1033529-.0078-.041341-.0052-.067179-.01292-.023255-.01033-.03359-.02584-.00775-.0155-.00775-.03617v-3.074749q0-.108521.056844-.15503.056844-.04651.1266073-.04651h.2687176q.082682 0 .1446941.0155.062012.0155.1085206.04909.046509.03359.077515.08527.031006.05168.05426.12144l.9689337 2.421042h.012919l1.007691-2.413291q.028422-.07751.062012-.131775.03359-.05426.072347-.08527.041341-.03359.090434-.04651.049093-.0155.1136883-.0155h.2816367q.038757 0 .072347.01292.036174.01033.059428.03617.025838.02326.041341.06201.015503.03617.015503.09043zM10.372236 12.800251q0 .250631-.08268.45217-.08268.201538-.237712.343648-.1524456.14211-.3772382.219625-.2222088.07752-.5322676.07752h-.379822v1.204061q0 .02067-.012919.03617-.010335.0155-.036174.02584-.023254.0078-.067179.01292-.041341.0078-.1059368.0078-.064596 0-.1085206-.0078-.041341-.0052-.067179-.01292-.025838-.01033-.036174-.02584-.010335-.0155-.010335-.03617v-3.085085q0-.103352.05426-.147277.05426-.04392.1214397-.04392h.715719q.1085206 0 .2067059.01033.1007691.0078.2351279.03876.1369426.02842.2764691.111105.1421105.0801.2402955.198954.09819.118856.149862.276469.05426.155029.05426.343648zm-.467672.03617q0-.204122-.077515-.341065-.074931-.136942-.188619-.204122-.1111044-.06718-.2325441-.08527-.1188559-.01809-.2325441-.01809H8.7625142v1.341005h.4004926q.2015382 0 .3333132-.05168.1343588-.05168.2247926-.14211.090434-.09302.1369426-.219625.046509-.129191.046509-.279053zM13.142094 14.213603q0 .08527-.02584.134359-.02584.04909-.07235.04909h-.377238v.7028q0 .02067-.01033.03617-.01034.01292-.03617.02325-.02584.01034-.06718.0155-.04134.0052-.105937.0052-.06201 0-.103353-.0052-.04134-.0052-.06718-.0155-.02326-.01033-.03359-.02325-.0078-.0155-.0078-.03617v-.7028h-1.379761q-.03101 0-.05168-.0078-.02067-.0078-.03876-.02842-.0155-.02067-.02325-.05943-.0052-.03876-.0052-.100769 0-.04909.0026-.08785.0026-.03876.01033-.06976.0078-.03359.02067-.06201.01292-.03101.03101-.0646l1.204061-2.030885q.01292-.02067.03617-.03617.02584-.0155.0646-.02584.03876-.01033.0956-.01292.05684-.0052.134359-.0052.08527 0 .147278.0078.0646.0052.103352.0155.03876.01033.05943.02842.02067.0155.02067.03876v2.134238h.377238q.04393 0 .06976.04651.02842.04392.02842.136943zm-.906922-2.017966h-.0052l-1.08779 1.834514h1.092957z",
    fontWeight: 400,
    className: "color000000 svgShape"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp);
export default __webpack_public_path__ + "static/media/mp.f10309fe910018478da182b320f220e0.svg";
export { ForwardRef as ReactComponent };